export default {
  interfaceColorBand1: '#2D8FC4',
  interfaceColorBand2: '#2D8FC4',
  interfaceColorBand3: '#5da462',
  interfaceColorBand4: '#2D8FC4',
}
